var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulbFillBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bulb-fill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,7 C14.757,7 17,9.243 17,12 C17,13.579 16.246,15.062 15,15.996 L15,15.996 L15,20 C15,21.103 14.103,22 13,22 L13,22 L11,22 C9.897,22 9,21.103 9,20 L9,20 L9,15.996 C7.753,15.062 7,13.579 7,12 C7,9.243 9.243,7 12,7 Z M21,11 C21.553,11 22,11.447 22,12 C22,12.553 21.553,13 21,13 L21,13 L19,13 C18.447,13 18,12.553 18,12 C18,11.447 18.447,11 19,11 L19,11 Z M5,11 C5.552,11 6,11.447 6,12 C6,12.553 5.552,13 5,13 L5,13 L3,13 C2.448,13 2,12.553 2,12 C2,11.447 2.448,11 3,11 L3,11 Z M4.8067,5.054 C5.1917,4.657 5.8237,4.645 6.2207,5.028 L6.2207,5.028 L7.6597,6.418 C8.0567,6.802 8.0677,7.436 7.6837,7.832 C7.4877,8.035 7.2267,8.138 6.9647,8.138 C6.7147,8.138 6.4647,8.045 6.2697,7.857 L6.2697,7.857 L4.8307,6.468 C4.4337,6.084 4.4227,5.45 4.8067,5.054 Z M17.7794,5.0297 C18.1754,4.6467 18.8114,4.6577 19.1924,5.0537 C19.5764,5.4497 19.5654,6.0837 19.1684,6.4667 L19.1684,6.4667 L17.7294,7.8567 C17.5364,8.0437 17.2854,8.1377 17.0354,8.1377 C16.7734,8.1377 16.5114,8.0347 16.3164,7.8317 C15.9324,7.4357 15.9434,6.8017 16.3404,6.4187 L16.3404,6.4187 Z M12,2 C12.552,2 13,2.447 13,3 L13,3 L13,5 C13,5.553 12.552,6 12,6 C11.448,6 11,5.553 11,5 L11,5 L11,3 C11,2.447 11.448,2 12,2 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bulb-fill",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\uD83C\\uDFA8-Icon-\\u0421olor",
    fill: "#0068F5",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbFillBlue);
export default __webpack_public_path__ + "static/media/bulb-fill-blue.abf726ae5a2d52ee26962c636939e88e.svg";
export { ForwardRef as ReactComponent };